(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.row.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.row.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.tipsinfo.tableComponents,
  TableHeaderCell = _svs$components$tipse.TableHeaderCell,
  TableContentCell = _svs$components$tipse.TableContentCell;
const TableRow = _ref => {
  let children = _ref.children,
    className = _ref.className,
    _ref$dataTestId = _ref.dataTestId,
    dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId;
  return React.createElement("tr", {
    className: clx('tipsinfo_table__row', className),
    "data-testid": dataTestId
  }, children);
};
TableRow.HeaderCell = TableHeaderCell;
TableRow.ContentCell = TableContentCell;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableRow', TableRow);

 })(window);